import { create } from "zustand"

export type BuyerNavItem =
  | "dashboard"
  | "overview"
  | "explore"
  | "browse-products"
  | "browse-supplier"
  | "rfqs"
  | "quotations"
  | "orders"
  | "logistics"
  | "settings"
  | "profile"
  | "submit-rfq"
  | "complaints"
  | "notifications"

interface BuyerUIState {
  activeNav: BuyerNavItem
  sidebarCollapsed: boolean
  scrolledPastHero: boolean
  isScrolled: boolean
  setActiveNav: (nav: BuyerNavItem) => void
  toggleSidebar: () => void
  setSidebarCollapsed: (collapsed: boolean) => void
  setScrolledPastHero: (val: boolean) => void
  setIsScrolled: (val: boolean) => void
}

export const useBuyerUIStore = create<BuyerUIState>((set) => ({
  activeNav: "dashboard",
  sidebarCollapsed: typeof window !== "undefined" ? window.innerWidth < 768 : false,
  scrolledPastHero: false,
  isScrolled: false,
  setActiveNav: (activeNav) => set({ activeNav }),
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
  setScrolledPastHero: (scrolledPastHero) => set({ scrolledPastHero }),
  setIsScrolled: (isScrolled) => set({ isScrolled }),
}))
